import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/constants";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? m[1] : null;
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sid });
        if (data.token) localStorage.setItem("ce_token", data.token);
        setUser(data.user);
        // Clear hash
        window.history.replaceState(null, "", window.location.pathname);
        const isStaff = (data.user.roles || []).some(r => ["admin", "dispatcher", "driver"].includes(r));
        nav(isStaff ? "/dashboard" : "/portal-select", { state: { user: data.user } });
      } catch (e) {
        nav("/login?error=oauth");
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <img src={LOGO_URL} alt="logo" className="h-16 w-16 object-contain mx-auto animate-pulse" />
        <p className="mt-4 font-bold text-slate-900">Signing you in…</p>
      </div>
    </div>
  );
}
